/**
 * @fileoverview Hook UI Layer para configuración de botones y estilos de ConversationTopicsMC.
 * @module useConversationTopicsUI
 * @category Hook - UI Layer
 * @since 3.1.0
 * @version 3.1.0
 */
import { useMemo } from 'react';

/**
 * Hook UI Layer para configuración de botones y estilos de ConversationTopicsMC.
 *
 * - Memoiza configuraciones de botones
 * - Solo lógica de presentación
 *
 * @returns {Object} Configuración de botones para el componente
 * @see useConversationTopicsData
 */
export default function useConversationTopicsUI() {
  // Configuración de botón para paginación
  const toggleButtonConfig = useMemo(() => ({
    outlined: true,
    size: 'xs',
    variant: 'SECONDARY',
    className: 'tw-border-0 tw-bg-transparent hover:tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-px-2 tw-py-1',
    iconClassName: '!tw-w-4 !tw-h-4 tw-flex-shrink-0 tw-text-blue-500'
  }), []);

  return useMemo(() => ({
    toggleButtonConfig
  }), [toggleButtonConfig]);
}
